module.exports = "/_next/static/images/StreamlineCompliance@2x-12a839ba93a7a6ae89ae88f69403069e.png";